import styled from '@emotion/styled'

export const AdminStatus = styled.div`
  position: absolute;
  right: 40px;
  top: 10px;
  z-index: 10;

  @media (max-width: 768px) {
    position: relative;
    right: auto;
    top: auto;
  }
`
